import React from 'react';
import styled from 'styled-components';
import {useOutlet, useOutletSetter} from 'reconnect.js';

const InfoSection = () => {
  return (
    <div style={{padding: 20}}>
      <Section1 extraStyle={{marginTop: 50}} />
      <Section2 extraStyle={{marginTop: 50}} />
      <Section3 extraStyle={{marginTop: 50}} />
      <Section4 extraStyle={{marginTop: 50}} />
      <Section5 extraStyle={{marginTop: 50}} />
      <Section6 extraStyle={{marginTop: 50}} />
      <Section7 extraStyle={{marginTop: 50}} />
      <Section8 extraStyle={{marginTop: 50}} />
    </div>
  );
};

const Section1 = ({extraStyle}) => {
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>FFP DAO</h1>
      <p>
        $ffp is applicable to the ecological economic system of both WEB3 and
        the fox fairy project.
      </p>
      <p>
        The FFP DAO is a system that earns tangible rewards in WEB3 through
        faith, ritual, dedication, doctrine, religious organization, activities,
        and fund management.
      </p>

      <p>
        FFP is a token used for a crucial step in building faith and supporting
        community development.
      </p>
      <p>
        It will serve as a decentralized protocol layer for community-led
        initiatives, driving faith into the decentralized world.
      </p>
    </div>
  );
};

const Section2 = ({extraStyle}) => {
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>Beliefs of the Fox Fairy Project</h1>
      <h3 style={{fontSize: '1.1rem'}}>Evolution:</h3>
      <p>
        We embrace setbacks and challenges, and the fox fairy is courageous in
        innovating to overcome crises and constantly evolve.
      </p>
      <h3 style={{fontSize: '1.1rem'}}>Equality:</h3>
      <p>One $FFP has the same value as another $FFP.</p>
      <h3 style={{fontSize: '1.1rem'}}>Community:</h3>
      <p>The faith constructed by the community is unbreakable.</p>
      <h3 style={{fontSize: '1.1rem'}}>Transparency:</h3>
      <p>
        The decision-making process and outcomes of the DAO are fully public.
      </p>
      <h3 style={{fontSize: '1.1rem'}}>Success:</h3>
      <p>Partial success is just the beginning.</p>
    </div>
  );
};

const Section3 = ({extraStyle}) => {
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>FFP Foundation</h1>
      <p>The FFP Foundation is the manager of $ffp.</p>
      <p>
        The foundation promotes fox fairy belief, belief organization,
        decentralization, community, and roles, with governance and coordination
        led by believers in the DAO, and aims to gradually move the DAO towards
        decentralized governance over time.
      </p>
      <p>
        Its mission is to manage the decision-making process of the Fox Fairy
        DAO, and be responsible for ensuring the execution of decisions,
        reporting community results, bookkeeping, daily task management, DAO
        management, and other tasks, to ensure that the Fox Fairy's beliefs and
        the ideas of the DAO community are realized.
      </p>
    </div>
  );
};

const Section4 = ({extraStyle}) => {
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>FFP Elder Council</h1>
      <p>
        FFP Elder Council oversees the organization, processes, members, and
        founding team in response to the requests of ffp DAO members and reviews
        proposals and administrative procedures in accordance with the code of
        conduct.
      </p>
    </div>
  );
};

const Section5 = ({extraStyle}) => {
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>FFP Bishop</h1>
      <p>
        The FFP Bishop is primarily responsible for promoting the teachings,
        education, conducting rituals, and way of life of the Fox Goddess,
        ensuring accurate transmission of beliefs to followers in decentralized
        governance.
      </p>
      <p>
        Initially, the FFP Bishop's term of office is for 2 months, after which
        DAO members will vote for Board members.
      </p>
    </div>
  );
};

const Section6 = ({extraStyle}) => {
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>FFP Knight Order</h1>
      <p>
        The Knight Order is the organization responsible for external
        communication and collaboration of Fox Fairy DAO, with the main purpose
        of maintaining cooperative relationships with other projects.
      </p>
      <p>
        The initial term of service for the Knightly Order members is two
        months, after which the DAO members will vote for new members.
      </p>
    </div>
  );
};

const Section7 = ({extraStyle}) => {
  const [dimension] = useOutlet('dimension');
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>FFP Protocol</h1>
      <p>
        ffp is an ERC-20 governance and utility token used in the Fox Fairy
        ecosystem, used for building decentralized faith and community.
      </p>

      <p>The uses of ffp are as follows:</p>

      {[
        [
          'Incentive system',
          'ffp serves as the foundation of the reward mechanism for the Fox Fairy faith and is a tool for believers to participate in the future services and faith of the Fox Fairy project.',
        ],
        [
          'Governance',
          '$ffp is the governance token of the faith system, allowing $ffp holders to participate in the governance and decision-making of FFP DAO.',
        ],
        [
          'Value sharing',
          'ffp is a token with actual value in the ecosystem, providing all participants with an equal, transparent, and shared currency.',
        ],
        [
          'Usage rights',
          'ffp provides access rights to certain parts of the ecosystem, such as exclusive events, exclusive roles, special services, and community access.',
        ],
      ].map((data) => {
        return (
          <div
            key={data[0]}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: dimension.rwd === 'desktop' ? 'row' : 'column',
              marginBottom: 10,
            }}>
            <div style={{flex: 1, fontSize: '1.1rem', color: '#4F200D'}}>
              {data[0]}
            </div>
            <div style={{flex: 3, color: '#210062'}}>{data[1]}</div>
          </div>
        );
      })}
    </div>
  );
};
const Section8 = ({extraStyle}) => {
  const [dimension] = useOutlet('dimension');
  return (
    <div style={{width: '100%', maxWidth: 1024, ...extraStyle}}>
      <h1 style={{color: '#FF6000'}}>Distribution of FFP</h1>
      <p>
        The total supply of ffp tokens is permanently fixed at 1 billion, and
        the total supply will never increase or decrease.
      </p>

      <p>
        Part of the tokens for project contributors will be initially locked.
        They will be unlocked according to the predetermined unlocking schedule
        in the table below, starting from the date of release.
      </p>

      <p>
        ffp will be distributed across 7 main categories, as detailed in the
        table below.
      </p>

      {[
        [
          '14% of the FFP will be allocated to Fox Fairy Project and its derivative NFT holders.',
          '140,000,000 tokens will be distributed to Fox Fairy and its derivative series NFT holders, to be claimed upon token release.',
        ],
        [
          '40% to the DAO Treasury.',
          'Unlock 100,000,000 tokens at the time of release, and then unlock 6,250,000 tokens per month within 48 months.',
        ],
        [
          '14% for the founding team.',
          'Initially locked for 12 months, followed by a monthly unlocking of 2916666.667 tokens for a duration of 48 months.',
        ],
        [
          '1% for charitable organizations.',
          'Locked for 12 months initially, then 208,333.3333 tokens will be unlocked each month for the following 48 months.',
        ],
        [
          '14% for the early supporters, core believers, and faith organizations.',
          '140,000,000 tokens allocated for contributors. The lock-up schedule varies based on the contributor but is one of the following: A - 10,000,000 tokens upfront, then unlock 1,041,666.667 tokens every month for 48 months. B - 10,000,000 tokens upfront, then unlock 729,166.6667 tokens every month for 48 months. C - 10,000,000 tokens upfront, then unlock 520,833.3333 tokens every month for 48 months.',
        ],
        [
          '16% for 5-year investors.',
          'Initial lock-up for 12 months, then unlock 2,666,666.667 tokens per month for 60 months.',
        ],
        [
          '1% for advisors with 5-year vesting.',
          'Locked for 12 months initially, followed by a monthly unlock of 166,666.6667 tokens for 60 months.',
        ],
      ].map((data) => {
        return (
          <div
            key={data[0]}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: dimension.rwd === 'desktop' ? 'row' : 'column',
              marginBottom: 10,
            }}>
            <div style={{flex: 1, fontSize: '1.1rem', color: '#4F200D'}}>
              {data[0]}
            </div>
            <div style={{flex: 3, color: '#210062'}}>{data[1]}</div>
          </div>
        );
      })}
    </div>
  );
};
export default InfoSection;
